import { mediaUrl } from "./api";

/** '/api/portraits/{id}/{hash}.jpg' → '{hash}_s.jpg' (≤96 px, generated on the server); other values (Google photos, data URLs) are returned unchanged. */
export const smallImage = (url) => {
  if (typeof url !== "string" || !/^\/api\/(portraits|avatars)\/[^/]+\/[^/]+\.(jpg|jpeg|png|webp)$/i.test(url) || /_s\.jpg$/i.test(url)) return url;
  return url.replace(/\.(jpg|jpeg|png|webp)$/i, "_s.jpg");
};

/** ≤ size px JPEG of a stored media file (160 list cards · 320 gallery tiles · 640 chat bubbles). */
export const thumbUrl = (path, size = 160) => mediaUrl(`/files/${path}`, `&thumb=${size}`);

/** Poster (first frame) of a stored video — same thumbnail route; the <video> can then use preload="none". */
export const posterUrl = (x, size = 640) => (x?.path && !x.url && !x.drive_id ? thumbUrl(x.path, size) : undefined);

/** onError for thumbnail <img>: falls back to the original file once if the thumbnail cannot be produced. */
export const onThumbError = (full) => (e) => { if (e.currentTarget.src !== full && !e.currentTarget.dataset.full) { e.currentTarget.dataset.full = "1"; e.currentTarget.src = full; } };
